<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box">
        <h5 class="form-header">Devoluciones a clientes</h5>
        <div class="controls-above-table">
          <div class="row">
            <div class="col-sm-12">
              <div action="#" class="form-inline justify-content-sm-end">
                <input
                  class="form-control form-control-sm rounded bright"
                  placeholder="Search"
                  v-model="searchtext"
                  type="text"
                  v-on:keyup.enter="filterData"
                />
                <div class="input-group-append">
                  <button
                    class="btn btn-link btn-sm"
                    type="button"
                    @click="filterData"
                  >
                    <i class="fa fa-search"></i>
                  </button>
                  <button
                    class="btn btn-link btn-sm"
                    type="button"
                    v-on:click="clearFilterData"
                  >
                    <i class="fa fa-times"></i>
                  </button>
                </div>
                <select
                  class="form-control form-control-sm rounded bright"
                  v-model="filterActiva"
                  @click="filterData"
                >
                  <option value="">Todos</option>
                  <option value="A">Abierto</option>
                  <option value="B">Cerrado</option>
                  <option value="9">Anulado</option>
                </select>
              </div>
              <br />
              <button
                class="btn btn-primary btn-block btn-md"
                @click="showModalAdddevolucionNew"
                type="button"
              >
                Nueva Devolución
                <i class="fa fa-plus"></i>
              </button>
            </div>
          </div>
        </div>
        <DevolucionesTableListComponent :dataTable="data" />
        <PaginationComponent
          :currentPage="currentPage"
          tipo="MINI"
          :data="data"
          @pagechanged="onPageChange"
        />
      </div>
    </div>
    <div
      aria-hidden="true"
      class="onboarding-modal modal fade animated"
      id="modalAdddevolucionNew"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog modal-lg modal-centered" role="document">
        <div class="modal-content">
          <button
            aria-label="Close"
            class="close"
            data-dismiss="modal"
            type="button"
          >
            <span class="close-label">Cancelar</span>
            <span class="os-icon os-icon-close"></span>
          </button>
          <div class="onboarding">
            <div class="onboarding-content with-gradient">
              <div class="text-center">
                <h4 class="onboarding-title">Escanear factura</h4>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <input
                    type="text"
                    v-if="!cargo_e"
                    class="form-control"
                    v-model="current.barra_factura"
                    ref="barrax"
                  />
                  <div v-if="cargo_e">
                    <table class="table table-hover">
                      <thead></thead>
                      <tbody>
                        <tr>
                          <td class="text-left">cliente:</td>
                          <td class="text-left">
                            {{ cargo_e.cliente.nombre }}
                          </td>
                        </tr>
                        <tr>
                          <td class="text-left">No. Factura:</td>
                          <td class="text-left">{{ cargo_e.numero }}</td>
                        </tr>
                        <tr>
                          <td class="text-left">Total Fac:</td>
                          <td class="text-left">{{ cargo_e.total }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <br />
                  <button
                    v-if="!cargo_e"
                    @click="buscarFactura()"
                    class="btn btn-success btn-md btn-block"
                  >
                    OK
                  </button>
                  <button
                    v-if="cargo_e"
                    @click="cargo_e = ''"
                    class="btn btn-dark btn-md btn-block"
                  >
                    Cambiar de Factura
                  </button>
                  <br />
                  <h6 v-if="cargo_e" class="text-center">¿Desde que caja?</h6>
                  <br />
                </div>
                <div class="col-md-12" v-if="cargo_e">
                  <TiendaSelectComponent
                    @change="refreshCajas()"
                    :current="current"
                  />
                </div>
                <div class="col-md-12" v-if="current && current.tienda">
                  <label>Caja</label>
                  <select class="form-control" v-model="current.caja">
                    <option
                      v-for="(det, key) in cajas"
                      :value="det.id"
                      :key="key"
                    >
                      <div>{{ det.caja }}</div>
                    </option>
                  </select>
                </div>
                <div v-if="current.caja" class="co-12">
                  <br />
                  <label>Observaciones</label>
                  <textarea
                    type="text"
                    class="form-control"
                    v-model="current.observacion"
                    ref="barrax"
                    name=""
                    id=""
                    cols="30"
                    rows="2" 
                  >
                  </textarea>
                  <br />
                </div>
                <button
                  v-if="current.caja"
                  @click="crearDevolucion()"
                  class="btn btn-success btn-md btn-block"
                >
                  Crear devolución
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PaginationComponent from "@/components/utils/PaginationComponent";
import DevolucionesService from "@/services/inventario/DevolucionesService";
import DynamicService from "@/services/commons/DynamicService";
import CargoComponentView from "@/components/commons/CargoComponentView";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import DevolucionesTableListComponent from "@/components/wms/devoluciones_clientes/DevolucionesTableListComponent";
import Notifications from "@/notifications/notifications";
import { mapGetters } from "vuex";

export default {
  components: {
    PaginationComponent,
    CargoComponentView,
    DevolucionesTableListComponent,
    TiendaSelectComponent,
  },
  data() {
    return {
      det: {
        id: "",
      },
      cargo_e: "",
      cajas: [],
      current: {},
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filterActiva: "",
      data: [],
    };
  },
  computed: {
    ...mapGetters({
      caja: "cargos/caja",
    }),
  },
  mounted() {
    let self = this;
    self.refreshData();
    $(".modal").on("shown.bs.modal", function () {
      self.$refs.barrax.focus();
    });
  },
  methods: {
    crearDevolucion() {
      let self = this;
      let current = Object.assign({}, self.current);
      current.cargo_id = self.cargo_e.id;
      DevolucionesService.save(current)
        .then((response) => {
          $("#modalAdddevolucionNew").modal("hide");
          self.$router.push({
            name: "wms-devoluciones-editar",
            params: { id: response.data.id },
          });
        })
        .catch((error) => {
          self.errors = error.response.data;
          if (self.errors.cargo_e) {
            Notifications.alert.error(
              "Generar devolución",
              self.errors.cargo_e
            );
          }
          if (self.errors.devolucion_cliente) {
            Notifications.alert.error(
              "Generar devolución",
              self.errors.devolucion_cliente
            );
          }
        });
    },
    refreshCajas() {
      let self = this;
      DynamicService.fetch("cxc", "caja", {
        tienda: this.current.tienda,
      }).then((response) => {
        self.cajas = response.data.results;
        self.cajas = self.cajas.filter((item) => item.esta_abierta == true);
      });
    },
    buscarFactura() {
      let self = this;
      let barra_factura = self.current.barra_factura;
      if (!barra_factura) {
        Notifications.alert.error(
          "Buscar factura",
          "Por favor escanear antes la barra de la factura"
        );
        return;
      }
      barra_factura = barra_factura.split("--");
      let tienda = barra_factura[0];
      let serie_factura = barra_factura[1];
      let numero_factura = barra_factura[2];
      DynamicService.fetch("cxc", "cargos", {
        tienda: tienda,
        cargo_serie: serie_factura,
        numero: numero_factura,
      })
        .then((response) => {
          self.cargo_e = response.data.results[0];
          if (!self.cargo_e) {
            Notifications.alert.error(
              "Buscar Factura",
              "No se encontro ninguna factura con los datos proporcionados"
            );
          }
        })
        .catch((erros) => {
          Notifications.alert.error(
            "Buscar Factura",
            "No se encontro ninguna factura con los datos proporcionados"
          );
        });
    },
    showModalAdddevolucionNew(detalle) {
      let self = this;
      $("#modalAdddevolucionNew").modal();
    },
    onPageChange(page) {
      this.currentPage = page;
      this.refreshData({
        page: this.currentPage,
        "filter[search]": this.searchtext,
        estado: this.filterActiva,
      });
    },
    filterData() {
      this.refreshData({
        page: 1,
        "filter[search]": this.searchtext,
        estado: this.filterActiva,
      });
    },
    clearFilterData() {
      this.searchtext = "";
      this.filterActiva = null;
      this.refreshData({
        page: 1,
        "filter[search]": this.searchtext,
        estado: this.filterActiva,
      });
    },
    hide: function () {
      this.$data.destroy();
    },
    refreshData(params) {
      let self = this;
      DevolucionesService.fetch(params).then((res) => {
        self.data = res.data;
      });
    },
    rowClick(current) {
      let self = this;
      if (event.ctrlKey) {
        let routeUrl = this.$router.resolve({
          name: "inventario-devoluciones-editar",
          params: { id: current.id },
        });
        window.open(routeUrl.href, "_blank");
      } else {
        self.$router.push({
          name: "inventario-devoluciones-editar",
          params: { id: current.id },
        });
      }
    },
    showModalEdit() {},
  },
};
</script>
